import React, {Component, Fragment} from "react";
import {Link, withRouter} from "react-router-dom";
import {Button, Col} from "reactstrap";
import "./home.css";
import LimitService from "../../../services/Limit/LimitService";
import SFXLoadingComponent from "../../../components/SFXLoadingComponent";
import BeneficiaryService from "../../../services/Beneficiary/BeneficiaryService";
import TransactionCardBrowser from "../../../components/Transaction/TransactionCardBrowser";
import BeneficiaryCardBrowser from "../../../components/Beneficiaries/BeneficiaryCardBrowser";
import SFXButtonComponent from "../../../components/SFXButtonComponent";
import UniversalTransactionService from "../../../services/Transaction/UniversalTransactionService";

const DAILY_SEND_LIMIT_TEXT = "Daily Send Limit:"
const MONTHLY_SEND_LIMIT_TEXT = "Monthly Send Limit:"

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            limitData: {},
            loading: true,
            transactionData: [],
            beneficiaryData: [],
            showSendMoneyButtons: false,
            showTransactionPopupMenu: false,
            showTransactionBeneficiaryOptions: false
        };
    }

    componentDidMount() {
        this.loadData();
        this.props.setHeader("Home");
        this.props.setSelectedScreen("Home");
    }

    loadData() {
        let requestCalls = [];

        requestCalls.push(LimitService.retrieveCustomerLimitByRegistrationId(this.props.customer.registrationId, "0"));
        requestCalls.push(UniversalTransactionService.retrieveUniversalTransaction(this.props.customer.registrationId, 10));
        requestCalls.push(BeneficiaryService.retrieveBeneficiariesByRegistrationId(this.props.customer.registrationId, "", 10));

        Promise.all(requestCalls).then(responseArray => {
            let limitData = responseArray[0];
            let transactionData = responseArray[1];
            let beneficiaryData = responseArray[2];

            if (!Array.isArray(beneficiaryData.body)) {
                beneficiaryData.body = [];
            }
            if (!Array.isArray(transactionData.body)) {
                transactionData.body = [];
            }

            this.setState({
                limitData: limitData,
                transactionData: transactionData.body,
                beneficiaryData: beneficiaryData.body,
                loading: false
            });

        });
    }

    render() {
        if (this.state.loading) {
            return <SFXLoadingComponent/>
        }

        return <Fragment>
            {this.state.showSendMoneyButtons && <div className={"grey_background"}
                                                     onClick={() => this.setState({showSendMoneyButtons: !this.state.showSendMoneyButtons})}/>}
            {this.props.isMobile ? <div className={"background_default"}>
                    {this.renderCircles("mobile")}
                    {this.renderLimits("mobile")}
                </div>
                :
                <div style={{display: "flex", height: "80%", flex: "5"}}>
                    <div style={{flex: "2"}}>
                        {this.renderBrowserHomeTables()}
                    </div>
                    <div className={"browser_home_screen_render_tables"} style={{flex: "1", margin: "auto"}}>
                        <br/>
                        {this.renderLimitsBrowser()}
                    </div>
                </div>
            }
        </Fragment>
    }

    //BROWSER VIEWS

    renderBrowserHomeTables() {

        return <Fragment>
            {this.state.beneficiaryData.length === 0 ?
                <Fragment>
                    <br/>
                    <div className={"beneficiaries_wrapper"} style={{
                        height: "35%",
                        boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                        borderRadius: "15px"
                    }}>
                        <div className={"browser_home_table_title"}>Beneficiaries</div>

                        <div style={{height: "80%", overflowY: "scroll", textAlign: "center"}}>
                            <br/>
                            You have no beneficiaries.
                            <br/>
                            Click below to create a beneficiary and start sending money now
                            <br/>
                            <br/>
                            <Link to={"/create-beneficiary"}>
                                <SFXButtonComponent className={"browser_orange_oval_button"}>
                                    Create Beneficiary
                                </SFXButtonComponent>
                            </Link>
                        </div>
                    </div>
                </Fragment>
                :
                <Fragment>
                    <br/>
                    <div className={"beneficiaries_wrapper"} style={{
                        height: "35%",
                        boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                        borderRadius: "15px"
                    }}>
                        <div className={"browser_home_table_title"}>Beneficiaries</div>

                        <div style={{height: "80%", overflowY: "scroll"}}>
                            {
                                this.state.beneficiaryData.map((beneficiary, index) => {
                                    return <Col sm={12} key={index}>
                                        <BeneficiaryCardBrowser
                                            beneficiary={beneficiary}
                                        />
                                    </Col>
                                })
                            }
                        </div>
                        <Link to={"/create-beneficiary"}>
                            <Button className={"browser_home_plus_button"}>
                                <div className={"fa fa-plus"}/>
                            </Button>
                        </Link>
                    </div>
                </Fragment>
            }
            <br/>
            <Fragment>
                <br/>
                <div className={"recent_transactions_wrapper"} style={{
                    height: "35%",
                    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                    borderRadius: "15px"
                }}>
                    <div>
                        <div className={"browser_home_table_title"}>Recent Transactions</div>
                    </div>
                    {this.state.transactionData.length === 0 ?
                        <div style={{height: "80%", overflowY: "scroll", textAlign: "center"}}>
                            <br/>
                            You have no transactions.
                            <br/>
                            Click below to create a transaction and start sending money now
                            <br/>
                            <br/>
                            <Link to={"/create-transaction"}>
                                <SFXButtonComponent className={"browser_orange_oval_button"}>
                                    Send Money Now
                                </SFXButtonComponent>
                            </Link>
                        </div>
                        : <Fragment>
                            <div
                                style={{height: "80%", overflowY: "scroll"}}>
                                {this.state.transactionData.map((transaction, index) => {
                                    return <Fragment key={index}>
                                        <Col sm={12}>
                                            <TransactionCardBrowser
                                                transactionData={transaction}
                                            />
                                        </Col>
                                    </Fragment>
                                })
                                }
                            </div>
                            {this.renderTransactionPopupMenu()}

                            {this.renderTransactionBeneficiaryOptions()}
                        </Fragment>
                    }
                </div>
            </Fragment>
        </Fragment>
    }

    renderLimitsBrowser(className = "browser") {
        return <div className={"limit_wrapper"} style={{textAlign: "center", margin: "auto", height: "100%", width: "100%"}}>
            <div>
                <div><b>{DAILY_SEND_LIMIT_TEXT}</b></div>
                <div>R {this.state.limitData.dailyLimitRemaining}</div>
                <Button className={"mobile_limit_item_currency"} disabled={true}>ZAR</Button>
            </div>
            <br/>
            <div>
                <div><b>{MONTHLY_SEND_LIMIT_TEXT}</b></div>
                <div>R {this.state.limitData.monthlyLimitRemaining}</div>
                <Button className={"mobile_limit_item_currency"} disabled={true}>ZAR</Button>
            </div>
            <br/>
            <div>
                <Link to={"/limit-increase"}>
                    <Button className={"browser_orange_oval_button"}>
                        Request Increase
                    </Button>
                </Link>
            </div>
        </div>
    }

    renderTransactionPopupMenu() {
        return <Fragment>
            {this.state.showTransactionPopupMenu &&
            <div style={{display: "-ms-flexbox", position: "relative", top: "-100px", left: "75%"}}>
                <div style={{flex: "1"}}>
                    <Button className={"browser_add_new_button_existing_beneficiary_home"}
                            onClick={() => this.setState({showTransactionBeneficiaryOptions: !this.state.showTransactionBeneficiaryOptions})}>
                        Send Money
                    </Button>
                </div>
                {!this.state.showTransactionBeneficiaryOptions &&
                <div style={{flex: "1"}}>
                    <Link to={"/redeem-transaction"}>
                        <Button className={"browser_add_new_button_new_beneficiary_home"}>Receive Money</Button>
                    </Link>
                </div>
                }
            </div>
            }
        </Fragment>

    }

    renderTransactionBeneficiaryOptions() {
        return <Fragment>
            {this.state.showTransactionBeneficiaryOptions &&
            <div style={{display: "-ms-flexbox", position: "relative", top: "-90px", left: "75%"}}>
                <div style={{flex: "1"}}>
                    <Link to={"/beneficiaries-existing"}>
                        <Button className={"browser_add_new_button_existing_beneficiary_home"}>New Beneficiary</Button>
                    </Link>
                </div>
                <div style={{flex: "1"}}>
                    <Link to={"/redeem-transaction"}>
                        <Button className={"browser_add_new_button_existing_beneficiary_home"}>Existing
                            Beneficiary</Button>
                    </Link>
                </div>
            </div>
            }
        </Fragment>

    }

    //MOBILE VIEWS

    renderCircles(className) {
        return <div className={className + "_circle_container"}>
            <div className={className + "_existing_bene_circle_div"}>
                <Button className={className + "_circle_button_existing"}
                        onClick={() => {
                            this.setState({showSendMoneyButtons: !this.state.showSendMoneyButtons})
                        }}
                >Send<br/>Money
                    <br/>
                    <div className={"fa fa-arrow-right"} style={{color: "#124892", fontSize: "20px"}}/>
                </Button>
                {this.renderTransactionNewAndExisting(className)}
            </div>
            <div className={className + "_new_bene_circle_div"}>
                <Link to={"/redeem-transaction"}>
                    <Button className={className + "_circle_button_new"}>Receive<br/>Money
                        <br/>
                        <div className={"fa fa-arrow-left"} style={{color: "#124892", fontSize: "20px"}}/>
                    </Button>
                </Link>
            </div>
        </div>
    }

    renderTransactionNewAndExisting(className) {

        return <Fragment>

            <div>
                {this.state.showSendMoneyButtons &&
                <div>
                    <Link to={"/beneficiaries-existing"}>
                        <Button className={className + "_add_new_button_existing_beneficiary_home"}>Existing
                            Beneficiary</Button>
                    </Link>
                    <Link to={"/create-transaction"}>
                        <Button className={className + "_add_new_button_new_beneficiary_home"}>New Beneficiary</Button>
                    </Link>
                </div>
                }
            </div>

        </Fragment>

    }

    renderLimits(className) {
        return <div className={className + "_limits"}>
            <div className={className + "_limit_div"}>
                <div className={className + "_limit_item_remaining"}>{DAILY_SEND_LIMIT_TEXT}</div>
                <div className={className + "_limit_item_amount"}>R {this.state.limitData.dailyLimitRemaining}</div>
                <Button className={className + "_limit_item_currency"} disabled={true}>ZAR</Button>
            </div>
            <br/>
            <div className={className + "_limit_div"}>
                <div className={className + "_limit_item_remaining"}>{MONTHLY_SEND_LIMIT_TEXT}</div>
                <div className={className + "_limit_item_amount"}>R {this.state.limitData.monthlyLimitRemaining}</div>
                <Button className={className + "_limit_item_currency"} disabled={true}>ZAR</Button>
            </div>
        </div>
    }
}

export default withRouter(Home);